import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import EmployeeTasksContainer from '../../containers/employees/EmployeeTasksContainer.jsx';

const EmployeeTasks = ({ slug, employeeId, search }) => (
  <>
    <Helmet>
      <title>Employee Profile | ChangeSync</title>
    </Helmet>
    <EmployeeTasksContainer
      slug={slug}
      employeeId={employeeId}
      search={search}
    />
  </>
);

EmployeeTasks.getInitialProps = ({ query }) => ({
  slug: query.slug,
  employeeId: Number(query.employeeId),
  search: query.search || '',
});

export default requireAuth(withRouterParams(EmployeeTasks));
